import { render } from "./InClassStudent.vue?vue&type=template&id=5d865b59"
import script from "./InClassStudent.vue?vue&type=script&lang=js"
export * from "./InClassStudent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dt_project_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__